import styled from "styled-components";

export const StyledHome = styled.div`
  .capa {
    height: 320px;
    width: 100%;
  }
`;

export const AlertContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  z-index: 1000;

  .alert {
    width: 400px;
    text-align: center;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Image = styled.img`
  height: 380px;
`;